import { useEffect, useRef, useContext } from 'react';
import { RideEventsContext } from '../context/RideEventsContext';

export function useRideEvents(onRefresh) {
  const subscribe = useContext(RideEventsContext);
  const onRefreshRef = useRef(onRefresh);
  useEffect(() => { onRefreshRef.current = onRefresh; });

  useEffect(() => {
    if (!subscribe) return;
    return subscribe(() => onRefreshRef.current());
  }, [subscribe]);
}
